import { useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';

const copy = {
  approve: ['Approve this draft?', 'Approval records your review; it does not publish the page.'],
  publish: ['Publish this page?', 'This approved version will become publicly readable and eligible for the sitemap.'],
  'return-to-draft': ['Return to draft?', 'If published, the page will be removed from public listings and its address will no longer show the content until it is reviewed and published again.'],
};

export const ReviewDialog = ({action, onClose, onConfirm, busy, onRestoreFocus}) => {
  const [checked, setChecked] = useState(false);
  const [title, description] = copy[action];
  const confirmationDisabled = busy || (action === 'approve' && !checked);
  const confirmLabel = {
    approve: 'Approve draft', publish: 'Publish page', 'return-to-draft': 'Return to draft',
  }[action];

  return (
    <Dialog open onOpenChange={open => { if (!open && !busy) onClose(); }}>
      <DialogContent
        className="staff-review-dialog"
        overlayClassName="staff-review-overlay"
        data-testid="review-dialog"
        onCloseAutoFocus={event => {event.preventDefault(); onRestoreFocus();}}
      >
        <DialogHeader>
          <DialogTitle data-testid="review-dialog-title">{title}</DialogTitle>
          <DialogDescription data-testid="review-dialog-description">
            {description}
          </DialogDescription>
        </DialogHeader>
        {action === 'approve' && (
          <label className="review-confirm-label" data-testid="review-confirm-label">
            <input
              type="checkbox"
              checked={checked}
              onChange={event => setChecked(event.target.checked)}
              data-testid="review-confirm-checkbox"
            />
            I confirm the firm has reviewed the legal statements, sources, dates, locations, and firm-specific claims.
          </label>
        )}
        <DialogFooter className="staff-review-footer">
          <Button variant="outline" disabled={busy} onClick={onClose} data-testid="review-dialog-cancel">
            Cancel
          </Button>
          <Button
            className="content-primary-button"
            disabled={confirmationDisabled}
            onClick={() => onConfirm(action, checked)}
            data-testid="review-dialog-confirm"
          >
            {busy ? 'Working…' : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};